// PURE DATA + loader arrows. Admin-only module: no public routes or menu items.
import type { ModuleManifest } from '../types';

export const crmModule: ModuleManifest = {
  id: 'crm',
  routes: [],
  adminPanel: __MODULE_ADMIN__
    ? { title: 'Clients', icon: 'clients', path: 'clients', load: () => import('./admin/ClientsPanel') }
    : undefined,
};
